import { render, staticRenderFns } from "./logo_and_brand_configurator.vue?vue&type=template&id=6fdd35fa&"
import script from "./logo_and_brand_configurator.vue?vue&type=script&lang=js&"
export * from "./logo_and_brand_configurator.vue?vue&type=script&lang=js&"
import style0 from "./logo_and_brand_configurator.vue?vue&type=style&index=0&id=6fdd35fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports